import React from 'react';
import { NavLink } from 'react-router-dom';
import logoImg from '../logo.svg';
import { Icon } from 'react-icons-kit';
import { menu } from 'react-icons-kit/feather/menu';
import { arrowLeft } from 'react-icons-kit/feather/arrowLeft'
import { useParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Sidebar from '../components/Sidebar';
import axios from 'axios';
import { useJwt } from "react-jwt"
import { CreateModule } from '../apiconfig/authService';

function AddModule(props) {
  const navigate = useNavigate();
  const { _, isExpired } = useJwt(localStorage.getItem('accessToken'));
  if (isExpired)
    navigate('/');

  const setMediaTableViewMessage = props.setMessage;

  const [moduleName, setModuleName] = useState('');

  const [message, setMessage] = useState('');
  const [isMessageRed, setIsMessageRed] = useState('');

  const handleModuleNameChange = (e) => {
    setModuleName(e.target.value);
  };

  const validateInput = () => {
    if (moduleName === '')
      throw new Error('Module Name is required.');
  };


  const handleSubmitClick = async (e) => {
    e.preventDefault();

    try {
      validateInput();
    } catch (error) {
      setIsMessageRed(true);
      setMessage(error.message);
      window.scrollTo(0, 0);
      return;
    }

    let response;
    try {
      response = await CreateModule({ modulename: moduleName }, localStorage.getItem('accessToken'))
      if (response.status === 201) {
        setMediaTableViewMessage(response.data.message);
        navigate("/module");
      }
    } catch (err) {
      if ((err.response && err.response.data) && err.response.data.error) {
        setIsMessageRed(true);
        setMessage(err.response.data.error);
        window.scrollTo(0, 0);
      } else {
        setIsMessageRed(true);
        setMessage('An error occurred. Please try again later.');
        window.scrollTo(0, 0);
      }
    }
  };

  return (
    <div className="dashboard-content">
      <Sidebar />
      {/* <div className="mobileOption d-flex align-items-center justify-content-between">
          <div  className="buyMore">
            <img className="img-fluid" src={logoImg} alt=""/>
          </div>
          <button className="btn btn-primary offCanvasToggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling"><Icon className="menu" icon={menu} size={25}/></button>
        </div> */}
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">Add Module</h1>
          <div className="d-inline-flex gap-2">
            <NavLink to="/module" className="btn btn-primary">View All</NavLink>
          </div>
        </div>

        {message && <div style={{ color: isMessageRed ? 'red' : 'black' }} className="alert alert-primary" role="alert">{message}</div>}

        <div role="tabpanel" className="personal-info tab-pane active" id="pi">
          {/* <h4 className="text-primary h6 fw-bold mb-3">Product main category information</h4> */}
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="form-floating mb-4">
                <input type="text" value={moduleName} onChange={handleModuleNameChange} className="form-control" id="catName" placeholder="Product Main Category Name" />
                <label htmlFor="catName">Module Name</label>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="form-group col-sm-12 col-lg-12 mb-3">
              <button type="submit" onClick={handleSubmitClick} className="btn btn-primary btn-lg save-btn text-uppercase">Add</button>
            </div>
          </div>
        </div>
        <hr />
      </div>
    </div>
  );
}
export default AddModule;
